import React, { useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { FiExternalLink } from "react-icons/fi";
import { useApprovals } from "../../../Pages/Vendors/VendorApprovals/useApprovals";
import { FetchDecisions } from "../../../../../utils/redux/Report/ReportSlice";
import { useDispatch, useSelector } from "react-redux";

function ViewProcessingStages({ schema, entityName, entityIdFieldName, id }) {
  const { openModal, closeModal } = useApprovals({});
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch decisions when the component mounts
    dispatch(
      FetchDecisions({
        schemaName: schema,
        entityName: entityName,
        entityIdFieldName: entityIdFieldName,
        entityId: parseInt(id),
      })
    );
  }, []); // The empty dependency array ensures that this effect runs only once when the component mounts



  
  const data = useSelector((state) => state.report);
  const page_data = data?.decision_data;

  // console.log(data,'data');
  // console.log(page_data,'page_data');

  const handleClick = () => {
    openModal({
      type: "approve",
      details: {
        button: {
          name: "Yes, Approve",
          color: "",
        },
        // isLoading: isLoading,
        isProcessingStages: true,
        sendIsOptional: false,
        commentIsOptional: false,
        title: "Approve Account",
        decisions:(page_data.statusCode=='99'?[]:page_data)
        // submitData: () => {
        //   dispatch(
        //     FetchDecisions({
        //       schema: schema,
        //       entityName: entityName,
        //       entityIdFieldName: entityIdFieldName,
        //       entityId: id,
        //     })
        //   );
        // },
        // submitData: (data) => {
        //   dispatch(
        //     ApproveVendorAction({
        //       comment: data?.comments,
        //       requestId: vendor?.requestId,
        //       emailTrigger: data?.send,
        //       designation: verifyUserApprovalLevel()?.authorizedPVM ? 1 : 0,
        //     })
        //   )?.then((res) => {
        //     closeModal();
        //     dispatch(GetSingleVendor({ id }));
        //   });
        // },
      },
    });


  };

    // Conditional rendering: Show button only when page_data length is more than 0
    if (!page_data || page_data.length === 0) {
      return null;
    }
  return (
    <button
      onClick={handleClick}
      type="button"
      className={DashboardStyle.view_more_action_button}
    >
      <span>Preview Stage</span>{" "}
      <FiExternalLink className={DashboardStyle.view_more_action_button_icon} />
    </button>
  );
}

export default ViewProcessingStages;
